export const Wifi = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
    >
      <path
        d="M12.5982 12.8714C12.4305 13.1621 12.0704 13.2542 11.7953 13.0758C9.5966 11.6567 6.8287 11.3353 3.56899 12.1223C3.25487 12.1979 2.94176 11.9899 2.8702 11.6579C2.79829 11.3259 2.99432 10.995 3.30922 10.9194C6.87645 10.0579 9.93632 10.4291 12.4048 12.023C12.6798 12.2014 12.7671 12.5807 12.5982 12.8714ZM13.7444 10.1768C13.5331 10.5401 13.0835 10.6547 12.7402 10.4314C10.223 8.79622 6.38598 8.32276 3.40863 9.27772C3.0225 9.40096 2.61467 9.17103 2.49748 8.76373C2.38118 8.35573 2.59891 7.92563 2.98437 7.80156C6.38531 6.71119 10.6133 7.23936 13.504 9.11632C13.8473 9.33964 13.9558 9.81452 13.7444 10.1768ZM13.8428 7.37123C10.8247 5.47702 5.84508 5.30285 2.96346 6.22698C2.50072 6.37527 2.01138 6.09925 1.87115 5.6103C1.73092 5.12113 1.99192 4.60442 2.45499 4.45577C5.76289 3.39471 11.2619 3.59971 14.7368 5.77939C15.1539 6.0404 15.2903 6.60839 15.0432 7.04759C14.7971 7.48738 14.2577 7.63236 13.8428 7.37123Z"
        fill="#07BE72"
        />
    </svg>
  );
};
export const Player = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
    >
      <path
        d="M6.85583 3.09368L13.2688 1.84255C13.561 1.78554 13.8334 2.005 13.8334 2.29746V11.9427C13.8334 12.7638 13.2484 13.4731 12.4303 13.6439L11.8637 13.7623C10.8767 13.9684 9.94711 13.2296 9.94711 12.2391C9.94711 11.5413 10.4262 10.9313 11.1136 10.7537L12.7194 10.3389C12.9373 10.2826 13.0892 10.0892 13.0892 9.86792V5.38976C13.0892 5.18388 12.8965 5.02999 12.6912 5.07189L7.34713 6.16219C7.18272 6.19573 7.06487 6.33794 7.06487 6.50277V13.1902C7.06487 14.0883 6.42468 14.864 5.52961 15.0504L5.1411 15.1313C4.12415 15.343 3.16675 14.5817 3.16675 13.5612C3.16675 12.9109 3.61266 12.342 4.25305 12.1753L5.93384 11.7378C6.141 11.6839 6.28524 11.4999 6.28524 11.2895V3.77605C6.28524 3.4441 6.52415 3.15839 6.85583 3.09368Z"
        fill="#07BE72"
      />
    </svg>
  );
};
export const Music = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
    >
      <path
        d="M8.49992 2.419C11.8535 2.419 14.5811 5.14654 14.5811 8.50016C14.5811 11.8538 11.8535 14.5813 8.49992 14.5813C5.1463 14.5813 2.41876 11.8538 2.41876 8.50016C2.41876 5.14654 5.1463 2.419 8.49992 2.419ZM8.49992 1.8335C4.81731 1.8335 1.83325 4.81755 1.83325 8.50016C1.83325 12.1828 4.81731 15.1668 8.49992 15.1668C12.1825 15.1668 15.1666 12.1828 15.1666 8.50016C15.1666 4.81755 12.1825 1.8335 8.49992 1.8335Z"
        fill="#07BE72"
      />
      <path
        d="M6.59497 12.3095L12.3093 8.33432L6.59497 4.69043V12.3095Z"
        fill="#07BE72"
      />
    </svg>
  );
};
export const Cloud = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
    >
      <g clipPath="url(#clip0_4741_1032)">
        <path
          d="M-2.33912 9.4638C-2.33319 9.41612 -2.29675 9.38268 -2.25085 9.38268C-2.20661 9.38268 -2.16995 9.4161 -2.16308 9.46357L-1.97239 10.6149L-2.16308 11.7466C-2.17017 11.7941 -2.20639 11.8271 -2.25085 11.8271C-2.29677 11.8271 -2.33319 11.7939 -2.33912 11.7462L-2.5 10.6149L-2.33912 9.4638Z"
          fill="#07BE72"
        />
        <path
          d="M-1.43767 8.67018C-1.3913 8.67018 -1.35369 8.70429 -1.34611 8.75375L-1.10031 10.6149L-1.34635 12.4353C-1.35391 12.4845 -1.39155 12.5189 -1.43767 12.5189C-1.48451 12.5189 -1.52308 12.4836 -1.52924 12.4348L-1.74549 10.6149L-1.52924 8.75375C-1.52286 8.7054 -1.48429 8.67018 -1.43767 8.67018Z"
          fill="#07BE72"
        />
        <path
          d="M1.89551 7.19235C1.89976 7.10543 1.97311 7.03701 2.06183 7.03701C2.15006 7.03701 2.22318 7.10543 2.2284 7.19235L2.42312 10.6165L2.2284 12.8289C2.2232 12.9155 2.15009 12.984 2.06183 12.984C1.97311 12.984 1.9 12.9158 1.89551 12.8293L1.72327 10.6165L1.89551 7.19235Z"
          fill="#07BE72"
        />
        <path
          d="M0.168797 8.34678C0.174265 8.27837 0.229863 8.22711 0.297997 8.22711C0.365421 8.22711 0.421018 8.27837 0.426953 8.34632L0.647453 10.6156L0.426953 12.8106C0.421018 12.8785 0.365421 12.9298 0.297997 12.9298C0.229841 12.9298 0.173999 12.8785 0.168797 12.8106L-0.0252039 10.6156L0.168797 8.34678Z"
          fill="#07BE72"
        />
        <path
          d="M4.05824 12.7932C4.05375 12.9002 3.96432 12.9838 3.8543 12.9838C3.74355 12.9838 3.6539 12.8999 3.65034 12.7938L3.50058 10.6173L3.65034 6.05906C3.65392 5.95208 3.74358 5.86828 3.85455 5.86828C3.96454 5.86828 4.054 5.95185 4.05849 6.05883L4.22719 10.6176L4.05824 12.7932Z"
          fill="#07BE72"
        />
        <path
          d="M7.8031 12.7321C7.80028 12.8766 7.67535 12.994 7.52392 12.994C7.37249 12.994 7.24711 12.8765 7.24471 12.7335C7.24471 12.7335 7.13943 10.6205 7.13943 10.6171L7.24471 5.35414C7.24709 5.20951 7.37224 5.09206 7.52389 5.09206C7.67532 5.09206 7.80048 5.20972 7.80308 5.35391L7.92094 10.6189L7.8031 12.7321Z"
          fill="#07BE72"
        />
        <path
          d="M5.91671 12.7591C5.91315 12.8861 5.80694 12.9858 5.67514 12.9858C5.5424 12.9858 5.43619 12.8861 5.43334 12.7604L5.30559 10.6183L5.4331 6.02631C5.43594 5.89929 5.54216 5.79989 5.67489 5.79989C5.80669 5.79989 5.91291 5.89927 5.91647 6.02631L6.06007 10.618L5.91671 12.7607V12.7591Z"
          fill="#07BE72"
        />
        <path
          d="M1.32413 12.8289C1.31822 12.9066 1.2548 12.9657 1.17648 12.9657C1.09699 12.9657 1.03383 12.9066 1.02863 12.8286L0.845722 10.6156L1.02863 8.51106C1.03359 8.4328 1.09701 8.37375 1.17648 8.37375C1.25506 8.37375 1.31846 8.43238 1.32413 8.51016L1.53187 10.6156L1.32413 12.8289Z"
          fill="#07BE72"
        />
        <path
          d="M-0.463135 12.743C-0.469759 12.8019 -0.516131 12.8445 -0.573373 12.8445C-0.631593 12.8445 -0.677965 12.8017 -0.683656 12.7426L-0.889016 10.6151L-0.683656 8.40696C-0.677743 8.34812 -0.631371 8.30532 -0.573395 8.30532C-0.516153 8.30532 -0.469781 8.34791 -0.462912 8.40696L-0.229853 10.6151L-0.463135 12.743Z"
          fill="#07BE72"
        />
        <path
          d="M6.33526 6.19435C6.33808 6.05707 6.45285 5.94986 6.59599 5.94986C6.73886 5.94986 6.85293 6.05707 6.85624 6.19389L6.98684 10.6187L6.85624 12.7475V12.7457C6.85295 12.883 6.73889 12.99 6.59599 12.99C6.45261 12.99 6.3381 12.8828 6.33526 12.7473L6.21886 10.6185L6.33526 6.19435Z"
          fill="#07BE72"
        />
        <path
          d="M3.14001 12.8152C3.13528 12.9122 3.05365 12.9882 2.95475 12.9882C2.85489 12.9882 2.7735 12.9122 2.7695 12.8161L2.60838 10.6171L2.76926 6.40984C2.77353 6.31289 2.85491 6.2369 2.95475 6.2369C3.05365 6.2369 3.13503 6.31266 3.14001 6.40984L3.32172 10.6171L3.14001 12.8152Z"
          fill="#07BE72"
        />
        <path
          d="M5.13995 10.6178L4.98381 12.7807C4.97976 12.8973 4.88231 12.988 4.76117 12.988C4.6398 12.988 4.54183 12.8964 4.53852 12.7805L4.39965 10.6176L4.5383 5.90551C4.54159 5.78829 4.63953 5.6967 4.76115 5.6967C4.88206 5.6967 4.98001 5.78852 4.98381 5.90551L5.13995 10.6178Z"
          fill="#07BE72"
        />
        <path
          d="M15.7475 8.0994C16.0698 7.97215 16.4235 7.9015 16.7942 7.9015C18.2886 7.9015 19.5 9.04301 19.5 10.4509C19.5 11.8587 18.2884 13 16.794 13C16.7458 13 9.30007 12.9964 9.2932 12.9958C9.13159 12.9804 9.00312 12.8504 9.00099 12.6944V4.60441C9.00288 4.45576 9.05729 4.3791 9.26148 4.30465C9.78695 4.11322 10.382 4 10.9924 4C13.4871 4 15.5322 5.80211 15.7475 8.0994Z"
          fill="#07BE72"
        />
        <path
          d="M8.14947 4.87742C8.15185 4.72299 8.28527 4.59729 8.44781 4.59729C8.60987 4.59729 8.74332 4.72299 8.74568 4.87698L8.87841 10.6196L8.74568 12.7038V12.7014C8.74332 12.8558 8.60987 12.9813 8.44781 12.9813C8.28529 12.9813 8.15185 12.8558 8.14971 12.7036L8.02738 10.6196L8.14947 4.87742Z"
          fill="#07BE72"
        />
      </g>
      <defs>
        <clipPath id="clip0_4741_1032">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0.5 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const Play = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="24"
      viewBox="0 0 19 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.49439 23.1317C2.39038 23.1317 1.49438 22.0117 1.49438 20.6317V3.79834C1.49438 2.41834 2.39038 1.29834 3.49439 1.29834C4.59839 1.29834 5.49439 2.41834 5.49439 3.79834V20.6317C5.49439 22.0117 4.59839 23.1317 3.49439 23.1317Z"
        fill="#07BE72"
        stroke="#07BE72"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.4944 23.1317C14.3904 23.1317 13.4944 22.0117 13.4944 20.6317V3.79834C13.4944 2.41834 14.3904 1.29834 15.4944 1.29834C16.5984 1.29834 17.4944 2.41834 17.4944 3.79834V20.6317C17.4944 22.0117 16.5984 23.1317 15.4944 23.1317Z"
        fill="#07BE72"
        stroke="#07BE72"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const Pause = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23"
      height="28"
      viewBox="0 0 23 28"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.57357 24.7629C3.65793 24.7629 2.91479 23.8261 2.91479 22.672V4.82966C2.91479 3.15695 3.65793 2.73877 4.57357 2.73877C5.48922 2.73877 6.23183 3.67549 6.23183 4.82966V22.672C6.23183 23.8261 5.48922 24.7629 4.57357 24.7629Z"
        fill="#07BE72"
        stroke="#07BE72"
        strokeWidth="0.418179"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.0323 14.5981C20.5504 15.3832 19.3694 15.5272 18.3962 14.9197L4.01991 22.6723L4.02067 5.94496C3.04752 5.33742 2.64889 4.20719 3.13087 3.42212C3.61286 2.63706 4.79384 2.49298 5.76699 3.10052L20.1426 12.0753C21.1157 12.6828 21.5143 13.813 21.0323 14.5981Z"
        fill="#07BE72"
        stroke="#07BE72"
        strokeWidth="0.418179"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.12982 23.9366C3.61181 24.7217 4.79279 24.8658 5.76594 24.2582L20.1413 15.4805C21.1145 14.873 21.5131 13.7427 21.0311 12.9577C20.5492 12.1726 19.3682 12.0285 18.395 12.6361L6.78416 7.61769L4.01962 21.4138C3.04646 22.0213 2.64784 23.1516 3.12982 23.9366Z"
        fill="#07BE72"
        stroke="#07BE72"
        strokeWidth="0.418179"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const RightArrow = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="33"
      height="33"
      viewBox="0 0 33 33"
      fill="none"
    >
      <path
        d="M5.07129 16.2122H27.9284M27.9284 16.2122L21.4443 23.5474M27.9284 16.2122L21.4443 9.45212"
        stroke="#030003"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const RightArrowWhite = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M3.42847 11.7843H20.5713M20.5713 11.7843L15.7082 17.2856M20.5713 11.7843L15.7082 6.71422"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const Instagram = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M11.9977 8.99872C10.3451 8.99872 8.99647 10.3474 8.99647 12C8.99647 13.6526 10.3451 15.0013 11.9977 15.0013C13.6504 15.0013 14.999 13.6526 14.999 12C14.999 10.3474 13.6504 8.99872 11.9977 8.99872ZM20.9993 12C20.9993 10.7572 21.0106 9.52558 20.9408 8.28499C20.871 6.84402 20.5423 5.56515 19.4886 4.51144C18.4326 3.45548 17.156 3.12901 15.715 3.05921C14.4722 2.98941 13.2406 3.00067 12 3.00067C10.7572 3.00067 9.52558 2.98941 8.28499 3.05921C6.84402 3.12901 5.56515 3.45773 4.51144 4.51144C3.45548 5.5674 3.12901 6.84402 3.05921 8.28499C2.98941 9.52783 3.00067 10.7594 3.00067 12C3.00067 13.2406 2.98941 14.4744 3.05921 15.715C3.12901 17.156 3.45773 18.4348 4.51144 19.4886C5.5674 20.5445 6.84402 20.871 8.28499 20.9408C9.52783 21.0106 10.7594 20.9993 12 20.9993C13.2428 20.9993 14.4744 21.0106 15.715 20.9408C17.156 20.871 18.4349 20.5423 19.4886 19.4886C20.5445 18.4326 20.871 17.156 20.9408 15.715C21.0128 14.4744 20.9993 13.2428 20.9993 12ZM11.9977 16.6179C9.44227 16.6179 7.37988 14.5555 7.37988 12C7.37988 9.44452 9.44227 7.38213 11.9977 7.38213C14.5532 7.38213 16.6156 9.44452 16.6156 12C16.6156 14.5555 14.5532 16.6179 11.9977 16.6179ZM16.8047 8.27148C16.2081 8.27148 15.7263 7.78966 15.7263 7.193C15.7263 6.59635 16.2081 6.11452 16.8047 6.11452C17.4014 6.11452 17.8832 6.59635 17.8832 7.193C17.8834 7.33468 17.8556 7.475 17.8015 7.60593C17.7474 7.73686 17.6679 7.85582 17.5677 7.956C17.4676 8.05618 17.3486 8.13561 17.2177 8.18975C17.0867 8.24388 16.9464 8.27166 16.8047 8.27148Z"
        fill="white"
        fillOpacity="0.8"
        />
    </svg>
  );
};
export const Twitter = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M17.1759 4.125H19.936L13.906 10.7965L20.9999 19.875H15.4454L11.095 14.369L6.11711 19.875H3.35532L9.80505 12.739L2.99988 4.125H8.69533L12.6277 9.15773L17.1759 4.125ZM16.2072 18.2758H17.7366L7.86429 5.64023H6.22307L16.2072 18.2758Z"
        fill="white"
        fillOpacity="0.8"
      />
    </svg>
  );
};
export const Facebook = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 9.05025C0 13.5248 3.24975 17.2455 7.5 18V11.4998H5.25V9H7.5V6.99975C7.5 4.74975 8.94975 3.50025 11.0002 3.50025C11.6497 3.50025 12.3503 3.6 12.9998 3.69975V6H11.85C10.7498 6 10.5 6.54975 10.5 7.25025V9H12.9L12.5002 11.4998H10.5V18C14.7502 17.2455 18 13.5255 18 9.05025C18 4.0725 13.95 0 9 0C4.05 0 0 4.0725 0 9.05025Z"
        fill="white"
        fillOpacity="0.8"
      />
    </svg>
  );
};
export const Youtube = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M21.5826 7.18694C21.4687 6.76346 21.2455 6.37727 20.9353 6.06702C20.625 5.75677 20.2386 5.53335 19.8147 5.41911C18.2545 5 12 5 12 5C12 5 5.74554 5 4.18527 5.41688C3.76121 5.53075 3.37461 5.75405 3.0643 6.06436C2.75399 6.37466 2.53089 6.76105 2.41741 7.18471C2 8.74522 2 12 2 12C2 12 2 15.2548 2.41741 16.8131C2.64732 17.6736 3.32589 18.3513 4.18527 18.5809C5.74554 19 12 19 12 19C12 19 18.2545 19 19.8147 18.5809C20.6763 18.3513 21.3527 17.6736 21.5826 16.8131C22 15.2548 22 12 22 12C22 12 22 8.74522 21.5826 7.18694ZM10.0134 14.9873V9.01274L15.192 11.9777L10.0134 14.9873Z"
        fill="white"
        fillOpacity="0.8"
      />
    </svg>
  );
};

export const Tiktok = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M13.825 1H10.7915V13.2608C10.7915 14.7218 9.62477 15.9218 8.17283 15.9218C6.72088 15.9218 5.55415 14.7218 5.55415 13.2608C5.55415 11.8261 6.69496 10.6522 8.09506 10.6V7.52175C5.00967 7.5739 2.52063 10.1044 2.52063 13.2608C2.52063 16.4435 5.06152 19 8.19877 19C11.336 19 13.8769 16.4174 13.8769 13.2608V6.9739C15.0177 7.8087 16.4177 8.30435 17.8956 8.33045V5.25217C15.614 5.17391 13.825 3.29565 13.825 1Z"
        fill="white"
        fillOpacity="0.8"
      />
    </svg>
  );
};
export const Cross = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M5 5L15 15M15 5L5 15"
        stroke="#07BE72"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const LeftArrow = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M17.1426 10.1797H2.85686M2.85686 10.1797L6.90947 5.59521M2.85686 10.1797L6.90947 14.4047"
        stroke="#07BE72"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const CorrectSign = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
    >
      <path
        d="M5 13.5L8 17.5L19 6.5"
        stroke="#030003"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const Hemburger = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M5 12H19M5 6H19M5 18H19"
        stroke="#07BE72"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const Plus = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12 4V20M4 12H20"
        stroke="#07BE72"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const Minus = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M3.33337 10L16.6667 10"
        stroke="#07BE72"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const LeftSide = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M11.6666 4.16665L5.83331 9.99998L11.6666 15.8333"
        stroke="#07BE72"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const DownSide = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M4.16665 7.49998L9.99998 13.3333L15.8333 7.49998"
        stroke="#07BE72"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const RightSide = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M8.33335 4.16665L14.1667 9.99998L8.33335 15.8333"
        stroke="#07BE72"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const CorrectIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
    >
      <path
        d="M4.08325 9.75L6.33325 12.75L14.5833 4.5"
        stroke="#80E6C5"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const RogerStudio = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="162"
      height="17"
      viewBox="0 0 162 17"
      fill="none"
    >
      <path
        d="M161.063 9C161.063 10.7136 160.734 12.166 160.075 13.3574C159.416 14.5488 158.523 15.4537 157.398 16.0722C156.277 16.6908 155.02 17 153.626 17C152.227 17 150.967 16.6882 149.846 16.0646C148.726 15.4411 147.836 14.5361 147.177 13.3498C146.523 12.1584 146.196 10.7085 146.196 9C146.196 7.28644 146.523 5.83397 147.177 4.64259C147.836 3.4512 148.726 2.54626 149.846 1.92776C150.967 1.30925 152.227 1 153.626 1C155.02 1 156.277 1.30925 157.398 1.92776C158.523 2.54626 159.416 3.4512 160.075 4.64259C160.734 5.83397 161.063 7.28644 161.063 9ZM157.215 9C157.215 7.98606 157.071 7.12928 156.782 6.42966C156.498 5.73004 156.087 5.20025 155.55 4.8403C155.018 4.48035 154.376 4.30038 153.626 4.30038C152.881 4.30038 152.239 4.48035 151.702 4.8403C151.165 5.20025 150.751 5.73004 150.462 6.42966C150.179 7.12928 150.037 7.98606 150.037 9C150.037 10.0139 150.179 10.8707 150.462 11.5703C150.751 12.27 151.165 12.7997 151.702 13.1597C152.239 13.5196 152.881 13.6996 153.626 13.6996C154.376 13.6996 155.018 13.5196 155.55 13.1597C156.087 12.7997 156.498 12.27 156.782 11.5703C157.071 10.8707 157.215 10.0139 157.215 9Z"
        fill="white"
      />
      <path d="M144.001 1.21289V16.787H140.236V1.21289H144.001Z" fill="white" />
      <path
        d="M130.351 16.787H124.595V1.21289H130.344C131.931 1.21289 133.297 1.52468 134.443 2.14825C135.593 2.76676 136.481 3.65903 137.104 4.82506C137.728 5.98602 138.04 7.37512 138.04 8.99236C138.04 10.6147 137.728 12.0088 137.104 13.1749C136.486 14.3409 135.601 15.2357 134.45 15.8593C133.299 16.4778 131.933 16.787 130.351 16.787ZM128.359 13.5779H130.207C131.079 13.5779 131.817 13.4309 132.42 13.1368C133.028 12.8377 133.487 12.3536 133.796 11.6844C134.111 11.0101 134.268 10.1128 134.268 8.99236C134.268 7.87195 134.111 6.97969 133.796 6.31555C133.482 5.64635 133.018 5.16473 132.405 4.87069C131.796 4.57157 131.046 4.42202 130.154 4.42202H128.359V13.5779Z"
        fill="white"
      />
      <path
        d="M118.479 1.21289H122.235V11.2585C122.235 12.4195 121.959 13.4309 121.406 14.2927C120.854 15.1495 120.083 15.8137 119.095 16.2851C118.106 16.7515 116.958 16.9848 115.65 16.9848C114.327 16.9848 113.171 16.7515 112.182 16.2851C111.194 15.8137 110.425 15.1495 109.878 14.2927C109.33 13.4309 109.057 12.4195 109.057 11.2585V1.21289H112.821V10.9315C112.821 11.4689 112.938 11.948 113.171 12.3688C113.409 12.7896 113.741 13.1191 114.167 13.3574C114.593 13.5957 115.087 13.7148 115.65 13.7148C116.213 13.7148 116.704 13.5957 117.125 13.3574C117.551 13.1191 117.883 12.7896 118.121 12.3688C118.36 11.948 118.479 11.4689 118.479 10.9315V1.21289Z"
        fill="white"
      />
      <path
        d="M94.0547 4.26993V1.21289H107.218V4.26993H102.496V16.787H98.7847V4.26993H94.0547Z"
        fill="white"
      />
      <path
        d="M88.8454 5.88213C88.7947 5.32446 88.5691 4.891 88.1686 4.58175C87.7732 4.26743 87.2079 4.11027 86.4728 4.11027C85.9861 4.11027 85.5805 4.17364 85.2561 4.30038C84.9316 4.42712 84.6883 4.60203 84.526 4.8251C84.3638 5.04309 84.2802 5.29404 84.2751 5.57795C84.265 5.81115 84.3106 6.01648 84.412 6.19392C84.5184 6.37136 84.6705 6.52852 84.8682 6.6654C85.071 6.79721 85.3144 6.91382 85.5983 7.01521C85.8822 7.1166 86.2016 7.20532 86.5565 7.28137L87.8949 7.58555C88.6655 7.75285 89.3448 7.97592 89.9329 8.25475C90.526 8.53359 91.0229 8.86565 91.4234 9.25095C91.829 9.63625 92.1357 10.0798 92.3435 10.5817C92.5514 11.0837 92.6579 11.6464 92.6629 12.27C92.6579 13.2535 92.4094 14.0976 91.9177 14.8023C91.4259 15.507 90.7187 16.0469 89.796 16.4221C88.8784 16.7972 87.7707 16.9848 86.4728 16.9848C85.1699 16.9848 84.0343 16.7896 83.066 16.3992C82.0977 16.0089 81.3448 15.4157 80.8074 14.6198C80.27 13.8238 79.9937 12.8175 79.9785 11.6008H83.5831C83.6135 12.1027 83.7478 12.5209 83.9861 12.8555C84.2244 13.1901 84.5514 13.4436 84.9671 13.616C85.3879 13.7883 85.8746 13.8745 86.4272 13.8745C86.9342 13.8745 87.3651 13.8061 87.72 13.6692C88.0799 13.5323 88.3562 13.3422 88.5489 13.0989C88.7415 12.8555 88.8404 12.5767 88.8454 12.2624C88.8404 11.9683 88.7491 11.7174 88.5717 11.5095C88.3942 11.2966 88.1205 11.1141 87.7504 10.962C87.3854 10.8048 86.9189 10.6603 86.3511 10.5285L84.7238 10.1483C83.3752 9.83904 82.3131 9.33967 81.5374 8.65019C80.7618 7.95564 80.3765 7.01774 80.3816 5.8365C80.3765 4.87326 80.635 4.02915 81.1572 3.30418C81.6794 2.57921 82.4018 2.01394 83.3245 1.60836C84.2472 1.20279 85.2992 1 86.4804 1C87.687 1 88.7339 1.20532 89.6211 1.61597C90.5134 2.02155 91.2054 2.59189 91.6971 3.327C92.1889 4.0621 92.4399 4.91381 92.45 5.88213H88.8454Z"
        fill="white"
      />
      <path
        d="M61.6465 16.787V1.21289H68.0799C69.246 1.21289 70.2523 1.42328 71.099 1.84407C71.9507 2.25979 72.6072 2.85801 73.0685 3.63875C73.5299 4.41441 73.7606 5.33456 73.7606 6.3992C73.7606 7.47905 73.5248 8.39667 73.0533 9.15206C72.5818 9.90237 71.9126 10.4752 71.0457 10.8707C70.1788 11.2611 69.1522 11.4562 67.9659 11.4562H63.8974V8.49046H67.2663C67.8341 8.49046 68.3081 8.41695 68.6883 8.26993C69.0736 8.11784 69.3651 7.8897 69.5628 7.58552C69.7606 7.27626 69.8594 6.88083 69.8594 6.3992C69.8594 5.91758 69.7606 5.51961 69.5628 5.20529C69.3651 4.88589 69.0736 4.64762 68.6883 4.49046C68.303 4.32823 67.829 4.24711 67.2663 4.24711H65.4107V16.787H61.6465ZM70.4145 9.66917L74.2929 16.787H70.1864L66.3841 9.66917H70.4145Z"
        fill="white"
      />
      <path
        d="M48.4307 16.787V1.21289H59.29V4.26993H52.1949V7.46384H58.7348V10.5285H52.1949V13.73H59.29V16.787H48.4307Z"
        fill="white"
      />
      <path
        d="M42.2345 6.30038C42.1483 5.98099 42.0216 5.69962 41.8543 5.45627C41.687 5.20786 41.4817 4.99747 41.2383 4.8251C40.995 4.65273 40.7161 4.52345 40.4018 4.43726C40.0875 4.34601 39.7428 4.30038 39.3676 4.30038C38.6122 4.30038 37.9582 4.48289 37.4056 4.84791C36.8581 5.21293 36.4348 5.74525 36.1357 6.44487C35.8365 7.13942 35.687 7.98352 35.687 8.97719C35.687 9.97592 35.8315 10.8276 36.1204 11.5323C36.4094 12.237 36.8277 12.7744 37.3752 13.1445C37.9227 13.5146 38.5869 13.6996 39.3676 13.6996C40.0571 13.6996 40.6401 13.5881 41.1166 13.365C41.5983 13.1369 41.9633 12.815 42.2117 12.3992C42.4601 11.9835 42.5843 11.4943 42.5843 10.9316L43.2839 11.0152H39.4969V8.26996H46.2117V10.3308C46.2117 11.725 45.9151 12.9189 45.322 13.9126C44.7339 14.9062 43.9227 15.6692 42.8885 16.2015C41.8594 16.7338 40.6756 17 39.3372 17C37.8517 17 36.5463 16.6781 35.4208 16.0342C34.2954 15.3904 33.4183 14.4728 32.7896 13.2814C32.161 12.0849 31.8467 10.6654 31.8467 9.02282C31.8467 7.74525 32.0368 6.61217 32.417 5.62357C32.7973 4.62991 33.327 3.78834 34.0064 3.09886C34.6908 2.40938 35.4817 1.8872 36.379 1.53232C37.2814 1.17744 38.2523 1 39.2915 1C40.194 1 41.033 1.12928 41.8087 1.38783C42.5894 1.64639 43.2789 2.01141 43.8771 2.48289C44.4804 2.95437 44.9696 3.51458 45.3448 4.1635C45.7199 4.81242 45.9531 5.52471 46.0444 6.30038H42.2345Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.7182 15.9214C27.5669 14.6499 28.8178 12.2088 28.8178 9.40603C28.8178 5.29211 26.1227 0.744507 22.7981 0.744507C19.4735 0.744507 16.7783 5.29211 16.7783 9.40603C16.7783 12.7693 18.5796 15.6119 21.0536 16.5373L20.5416 15.8662V15.011L19.5121 13.351L20.8505 11.9466L19.5121 10.6082V9.7159L18.1736 8.83806V6.77459L20.2777 8.3775H22.0622L21.6161 9.7159L23.4006 11.0543L22.0622 12.9049L22.9606 14.3637L23.6146 15.4201L23.7792 13.7878L24.081 12.6005H24.5841L24.9362 11.9466L25.5399 11.192V10.5381L25.9926 9.63258L27.6663 8.91051L26.5407 10.036L26.1656 10.7864V11.5367L25.6553 12.4395L25.3036 13.3615H24.9284L24.9268 13.9029L25.6772 15.7788L25.7182 15.9214Z"
        fill="#07BE72"
      />
      <path
        d="M0.938477 16.787V1.21289H7.37194C8.53797 1.21289 9.54431 1.42328 10.3909 1.84407C11.2427 2.25979 11.8992 2.85801 12.3605 3.63875C12.8219 4.41441 13.0525 5.33456 13.0525 6.3992C13.0525 7.47905 12.8168 8.39667 12.3453 9.15206C11.8738 9.90237 11.2046 10.4752 10.3377 10.8707C9.4708 11.2611 8.44418 11.4562 7.25787 11.4562H3.18943V8.49046H6.55825C7.12606 8.49046 7.60007 8.41695 7.9803 8.26993C8.3656 8.11784 8.65711 7.8897 8.85483 7.58552C9.05254 7.27626 9.1514 6.88083 9.1514 6.3992C9.1514 5.91758 9.05254 5.51961 8.85483 5.20529C8.65711 4.88589 8.3656 4.64762 7.9803 4.49046C7.595 4.32823 7.12099 4.24711 6.55825 4.24711H4.70274V16.787H0.938477ZM9.70654 9.66917L13.5849 16.787H9.4784L5.67612 9.66917H9.70654Z"
        fill="white"
      />
    </svg>
  );
};

export const CrossIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M6 6L18 18M18 6L6 18"
        stroke="#07BE72"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
